module.exports = __webpack_public_path__ + "img/xrp1ntel-report.1d8e458c.png";